import { useTranslation } from 'react-i18next';

import { AnnouncementActionEvent } from '@bonusly/common-announcements';
import { BookmarkOutline, CogOutline, MegaphoneOutline } from '@bonusly/design-system';
import { useDispatch } from '@bonusly/events';
import { useBuildRecognizeURL } from '@bonusly/url';

import { AppPath, Route } from '../../config/router';
import { NavGroup } from './NavGroup';
import { NavMenuItem } from './NavMenuItem';

export const NavMenuOptionsDesktop = ({ onClose }: { onClose: VoidFunction }) => {
	const { t } = useTranslation('navigation');
	const recognizeURL = useBuildRecognizeURL();
	const dispatch = useDispatch();
	const handleAnnouncementsClick = () => {
		dispatch(AnnouncementActionEvent.OpenAnnouncement);
		onClose();
	};

	const settingsUrl = recognizeURL(Route.Settings);

	return (
		<>
			<NavGroup>
				<NavMenuItem icon={<MegaphoneOutline />} onClick={handleAnnouncementsClick}>
					{t('links.announcements')}
				</NavMenuItem>

				<NavMenuItem icon={<BookmarkOutline />} to={AppPath.Bookmark} onClick={onClose}>
					{t('user_menu.bookmarks')}
				</NavMenuItem>

				<NavMenuItem icon={<CogOutline />} to={settingsUrl} onClick={onClose}>
					{t('user_menu.profile_settings')}
				</NavMenuItem>
			</NavGroup>
		</>
	);
};
